import { useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';

import { errorMessage, getVacancyIdFromUrl } from '../../shared/utils';
import { localStorageGet } from '../../services';
import { PREFERRED_CAREER_COUNTRY_KEY } from '../../shared/config/constants';
import { getVacancyForCountry } from '../services/vacancy';

export const useGetVacancy = () => {
    const { t } = useTranslation('PayseraRecruitmentBundle');
    const [vacancy, setVacancy] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const getVacancyDetails = async (countryCode) => {
        const id = getVacancyIdFromUrl();

        setLoading(true);

        try {
            const vacancyData = await getVacancyForCountry(id, countryCode);

            setVacancy(vacancyData);
        } catch (errors) {
            setError(t(errorMessage(errors)));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const storageCountryCode = localStorageGet(PREFERRED_CAREER_COUNTRY_KEY);

        getVacancyDetails(storageCountryCode);
    }, []);

    const refetch = (countryCode) => {
        getVacancyDetails(countryCode);
    };

    return {
        vacancy,
        loading,
        error,
        refetch,
    };
};
